import {useLocale} from '@aboutyou/i18n';
import {Experiment, FeatureToggleConfig, isExperiment} from './types';

export const featureDisabledByLocales = ({
  combinedConfig,
  locale,
}: {
  combinedConfig: FeatureToggleConfig;
  locale: ReturnType<typeof useLocale>;
}) => {
  if (
    !combinedConfig.enableForLocales ||
    !Array.isArray(combinedConfig.enableForLocales)
  ) {
    return undefined;
  }

  if (!combinedConfig.enableForLocales.includes(locale)) {
    return false;
  }

  return undefined;
};

export const featureEnabledByLocalesNoTimeFrameNorExperiment = ({
  combinedConfig,
  locale,
}: {
  combinedConfig: FeatureToggleConfig;
  locale: ReturnType<typeof useLocale>;
}) => {
  if (
    !combinedConfig.enableForLocales ||
    !Array.isArray(combinedConfig.enableForLocales)
  ) {
    return undefined;
  }

  if (!combinedConfig.enableForLocales.includes(locale)) {
    return undefined;
  }

  if (
    !combinedConfig.timeFrame &&
    !getExperimentValue(
      'experiment' in combinedConfig ? combinedConfig.experiment : undefined,
    )
  ) {
    return true;
  }

  return undefined;
};

export const getExperimentValue = (
  experiment?: Experiment | readonly Experiment[],
): string | boolean => {
  if (!experiment) return false;

  if (Array.isArray(experiment)) {
    const foundExperiment: Experiment = experiment.find(exp => exp.mapping);
    return (
      (foundExperiment?.mapping && Object.keys(foundExperiment.mapping)[0]!) ||
      false
    );
  }

  if (isExperiment(experiment)) {
    return Object.keys(experiment.mapping)[0]!;
  }

  return false;
};
